// Reusable right-side inspector drawer.  Renders inline when `embedded=true`,
// otherwise floats over the page.  Header has gradient hairline.

import { IconClose } from '../icons.jsx';

export function InspectorCard({
  open,
  onClose,
  title,
  eyebrow,
  children,
  actions,
  embedded = false,
  width = 'var(--inspector-width)',
}) {
  if (embedded) {
    return (
      <aside className="inspector inspector-embedded">
        <header className="inspector-header">
          <div className="inspector-headline">
            {eyebrow ? <div className="eyebrow">{eyebrow}</div> : null}
            <h3>{title}</h3>
          </div>
          {onClose ? (
            <button className="btn icon ghost" onClick={onClose} aria-label="Close inspector">
              <IconClose size={16} />
            </button>
          ) : null}
        </header>
        <div className="inspector-body">{children}</div>
        {actions ? <footer className="inspector-footer">{actions}</footer> : null}
      </aside>
    );
  }
  return (
    <div
      className={`inspector-overlay ${open ? 'open' : ''}`}
      aria-hidden={!open}
      onClick={onClose}
    >
      <aside
        className="inspector inspector-floating"
        style={{ width }}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <header className="inspector-header">
          <div className="inspector-headline">
            {eyebrow ? <div className="eyebrow">{eyebrow}</div> : null}
            <h3>{title}</h3>
          </div>
          <button className="btn icon ghost" onClick={onClose} aria-label="Close inspector">
            <IconClose size={16} />
          </button>
        </header>
        <div className="inspector-body">{children}</div>
        {actions ? <footer className="inspector-footer">{actions}</footer> : null}
      </aside>
    </div>
  );
}
